const CircleCheckThin = ({ width, height, className, fillColor }: CircleCheckThinProps) => (
  <svg className={className} width={width} height={height} viewBox='8 8 29 29' xmlns='http://www.w3.org/2000/svg'>
    <ellipse cx='22' cy='21.5' rx='13.75' ry='13.4375' fill='#1C8913' />
    <path
      d='M19.1808 25.1637L15.9684 22.0193C15.4572 21.5192 14.6445 21.5192 14.1334 22.0193C13.6222 22.5194 13.6222 23.3145 14.1334 23.8146L18.2502 27.8437C18.7614 28.3438 19.5871 28.3438 20.0983 27.8437L29.8666 18.2953C30.3778 17.7952 30.3778 17.0002 29.8666 16.5001C29.3555 16 28.5428 16 28.0317 16.5001L19.1808 25.1637Z'
      fill='#fff'
    />
  </svg>
);

export type CircleCheckThinProps = {
  fillColor: string;
  className?: string;
  width: string | number;
  height: string | number;
};

CircleCheckThin.defaultProps = {
  width: 100,
  height: 100,
  fillColor: '#1C8913',
};

export default CircleCheckThin;
